import {
  SET_APPS,
  SET_APPBUNDLES,
  SET_DEVICES,
  SET_USERS,
  SET_INSTALLED_APPS,
  SET_DEVICE_GROUPS,
  SET_ORGANIZATIONS,
  SET_GLOBAL_APPS,
  SET_GLOBAL_APPBUNDLES,
  UPDATE_INSTALLED_APP_DATA,
  SET_DEVICE_SYSTEM_VERSIONS,
  SET_API_KEYS
} from "../types";
import { mergeGlobalsAndOrgApps } from "../../utils/appUtils";
import { asArray, mapKV } from "../../utils/map";
import _ from "lodash";

const initialState = {
  organizations: {},
  apps: {},
  globalAppIds: [], // used to help us track app deletion
  orgAppIds: [], // used to help us track app deletion
  devices: {},
  deviceGroups: {},
  contentBundles: {},
  globalContentBundleIds: [], // used to help us track app deletion
  orgContentBundleIds: [], // used to help us track app deletion
  users: {},
  installedApps: {},
  installedAppsOnDevice: {},
  deviceSystemVersions: {},
  apiKeys: {},
};

const getDeviceGroupApprovedAppIds = ({
  deviceGroup: { contentBundleRefs, approvedApps },
  contentBundles
}) => {

  let allApprovedApps = [];
  if (contentBundleRefs)
    contentBundleRefs.map(bundle => {
      if (!contentBundles[bundle.id]) return;
      contentBundles[bundle.id].appRefs.map(
        ({ id }) => (allApprovedApps.push(id))
      );
    });
  if (approvedApps) approvedApps.map(({ id }) => (allApprovedApps.push(id)));
  return allApprovedApps;
};

const getDeviceIdsInGroup = ({ devices, deviceGroup }) => {
  let deviceIds = []
  Object.values(devices).forEach(device => {
    if (device.deviceGroupRef.id === deviceGroup._id) {
      deviceIds.push(device._id);
    }
  });
  return deviceIds;
}

// Installed App Data is added incrementally to device data via SET_INSTALLED_APPS and UPDATE_INSTALLED_APP_DATA
const mergeDeviceInstalledAppData = ({ devices, installedAppsToMerge }) => {
  if (!_.isEmpty(devices)) {
    _.merge(devices, installedAppsToMerge);
  }
}

const processDeviceGroups = ({ deviceGroups, contentBundles, devices }) => {
  // if (!_.isEmpty(deviceGroups) && !_.isEmpty(contentBundles) && !_.isEmpty(devices)) {
  mapKV(deviceGroups, (key, deviceGroup) => {
    deviceGroup.allApprovedAppIds = getDeviceGroupApprovedAppIds({ deviceGroup, contentBundles });
    deviceGroup.allDeviceIds = getDeviceIdsInGroup({ deviceGroup, devices })
  });
  // }
}

const processDevices = ({ devices, deviceGroups, organizations }) => {
  // if (!_.isEmpty(devices)) {
  //   _.forEach(devices, device => {
  //     device.deviceGroup = deviceGroups[device.deviceGroupRef.id];
  //     device.organization = organizations[device.organizationRef.id];
  //   })
  // }
}


// getDocIds and selectDocs are used to merge global and org level documents.
// Since these data come in two separate queries, we have to keep track of their ids and then select from the merged results.
// This process is needed to make sure we catch app deletion (that's it)
const getDocIds = (docs) => {
  let ids = []
  Object.values(docs).forEach(doc => {
    ids.push(doc._id);
  })
  return ids;
}

// See function comment above
const selectDocs = (selectedDocIds, allDocs) => {
  let resultDocs = {};
  selectedDocIds.forEach(docId => {
    resultDocs[docId] = allDocs[docId];
  })
  return resultDocs;
}

let hasInitializedDataTracker = {};
let requiredInitData = [
  SET_APPS,
  SET_APPBUNDLES,
  SET_DEVICES,
  SET_DEVICE_GROUPS,
  SET_GLOBAL_APPS,
  SET_GLOBAL_APPBUNDLES,
  SET_DEVICE_SYSTEM_VERSIONS
]

export default function (state = initialState, { type, payload }) {
  hasInitializedDataTracker[type] = true;
  if (requiredInitData.every(k => k in hasInitializedDataTracker)) {
    state = { ...state, hasInitializedDbData: true };
  }
  switch (type) {
    case SET_ORGANIZATIONS:
      processDevices({ devices: state.devices, deviceGroups: state.deviceGroups, organizations: payload });
      return {
        ...state,
        organizations: payload
      };
    case SET_APPS:
      state.orgAppIds = getDocIds(payload);
      state.apps = selectDocs([...state.orgAppIds, ...state.globalAppIds], { ...state.apps, ...payload });
      return state;
    case SET_GLOBAL_APPS:
      state.globalAppIds = getDocIds(payload);
      state.apps = selectDocs([...state.orgAppIds, ...state.globalAppIds], { ...state.apps, ...payload });
      return state;
    case SET_DEVICES:
      mergeDeviceInstalledAppData({ devices: payload, installedAppsToMerge: state.installedAppsOnDevice });
      processDevices({ devices: payload, deviceGroups: state.deviceGroups, organizations: state.organizations });
      return {
        ...state,
        devices: payload
      };
    case SET_DEVICE_GROUPS:
      processDeviceGroups({ deviceGroups: payload, contentBundles: state.contentBundles, devices: state.devices });
      processDevices({ devices: state.devices, deviceGroups: payload, organizations: state.organizations });
      return {
        ...state,
        deviceGroups: payload
      };
    case SET_APPBUNDLES:
      state.orgContentBundleIds = getDocIds(payload);
      state.contentBundles = selectDocs([...state.orgContentBundleIds, ...state.globalContentBundleIds], { ...state.contentBundles, ...payload });
      processDeviceGroups({ deviceGroups: state.deviceGroups, contentBundles: state.contentBundles, devices: state.devices });
      return state;
    case SET_GLOBAL_APPBUNDLES:
      state.globalContentBundleIds = getDocIds(payload);
      state.contentBundles = selectDocs([...state.orgContentBundleIds, ...state.globalContentBundleIds], { ...state.contentBundles, ...payload });
      processDeviceGroups({ deviceGroups: state.deviceGroups, contentBundles: state.contentBundles, devices: state.devices });
      return state;
    case SET_USERS:
      return {
        ...state,
        users: payload
      };
    case SET_INSTALLED_APPS:
      if (!_.isEmpty(payload)) {
        let installedAppsToMerge = {};
        installedAppsToMerge[payload.deviceId] = { installedApps: payload.installedApps };
        mergeDeviceInstalledAppData({ devices: state.devices, installedAppsToMerge });
      }
      return {
        ...state,
        installedApps: payload.installedApps || {} // TODO eventually should remove this and just rely on installedAppsOnDevice. One note: refreshing on a device info page leads to a race condition where this will get overwritten (I think)
      };
    case UPDATE_INSTALLED_APP_DATA:
      mergeDeviceInstalledAppData({ devices: state.devices, installedAppsToMerge: payload }); // doesn't handle uninstallation of apps?
      return {
        ...state,
        installedAppsOnDevice: payload
      }
    case SET_DEVICE_SYSTEM_VERSIONS:
      return {
        ...state,
        deviceSystemVersions: payload
      }
    case SET_API_KEYS:
      return {
        ...state,
        apiKeys: payload
      }
    default:
      return state;
  }
}
